import React, { FC } from 'react';

export const RequiredAsterisk: FC = React.memo(() => {
	return <span className="text-danger">*</span>;
});
